module.exports = __webpack_public_path__ + "static/media/fill.vertex.d40bb42e.glsl";